import { AxiosInstance } from 'axios';
import { useHttp } from '@Libs/http';
import { responseInterface } from 'swr';

const searchApi = (http: AxiosInstance) => ({
    async popularKeywords() {
        const response = await http.get('/search/popular_keywords');
        return response.data;
    },
    async searchHistory(queries = {}) {
        const response = await http.get('/search/search_history', {
            params: {
                limit: 4,
                offset: 0,
                ...queries
            },
        });
        return response.data;
    },
    async deleteSearchHistory(consumerSearchTermId: string) {
        const response = await http.delete(`/search/search_history/${consumerSearchTermId}`);
        return response.data;
    },
    async query(query: string, version = 'v2') {
        if (!query) return [];

        const response = await http.get('/search/query', {
            params: {
                q: query,
                v: version,
            },
        });
        return response.data?.results || [];
    },
});

const POPULAR_KEY = 'popular_search';
export const getPopularKeywords = (key = POPULAR_KEY): responseInterface<any, any> => useHttp(key, async ({ userHttp }) => await searchApi(userHttp).popularKeywords());

const SEARCH_HISTORY = 'search_history';
export const getSearchHistory = (queries?: { [key: string]: any }, key = SEARCH_HISTORY): responseInterface<any, any> =>
    useHttp(key, async ({ userHttp }) => await searchApi(userHttp).searchHistory(queries), {
        auth: true,
    });

export default searchApi;
